import type {ApiKeyADto} from '@cohort/admin-schemas/apiKeys';
import Button from '@cohort/merchants/components/buttons/Button';
import Table from '@cohort/merchants/components/Table';
import {formatDate} from '@cohort/shared/utils/format';
import {Trash} from '@phosphor-icons/react';
import React from 'react';
import {useTranslation} from 'react-i18next';

type ApiKeysTablerops = {
  apiKeys: ApiKeyADto[];
  onDeleteApiKey: (id: string) => void;
};

const ApiKeysTable: React.FC<ApiKeysTablerops> = ({apiKeys, onDeleteApiKey}) => {
  const {t} = useTranslation('pages', {
    keyPrefix: 'settings.integrations.apiKeysTable',
  });
  const headers = [
    {label: t('columnName')},
    {label: t('columnKey')},
    {label: t('columnDate')},
    {label: t('columnAction')},
  ];
  return (
    <Table headers={headers} outlined className="mt-4">
      {apiKeys.map(apiKey => (
        <tr key={apiKey.id}>
          <td className="whitespace-nowrap px-4 py-4 font-medium">{apiKey.name}</td>
          <td className="whitespace-nowrap px-4 py-4">{apiKey.redacted} </td>
          <td className="whitespace-nowrap px-4 py-4">{formatDate(apiKey.createdAt)}</td>
          <td className="whitespace-nowrap px-4 py-4">
            <Button variant="destructive" onClick={() => onDeleteApiKey(apiKey.id)}>
              <Trash className="-ml-1 mr-2 h-5 w-5" />
              {t('btnDelete')}
            </Button>
          </td>
        </tr>
      ))}
    </Table>
  );
};

export default ApiKeysTable;
